<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Mountings"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>
          Interprerive GRAPHICS/EnviroSIGNS offers virtually every type of interpretive, historical, and
          commemorative signage mounting method.
          <ul>
            <li><router-link :to="{ name: 'general' }">General Frames and Mountings</router-link></li>
            <li><router-link :to="{ name: 'nps' }">NPS Style Exhibit Bases</router-link></li>
            <li><router-link :to="{ name: 'duraframes' }">DuraFrames and Mountings</router-link></li>
            <li><router-link :to="{ name: 'pedestals' }">Pedestals and Posts</router-link></li>
            <li><router-link :to="{ name: 'kiosks' }">Kiosks and Structures</router-link></li>
            <li><router-link :to="{ name: 'bulletin-boards' }">Bulletin Boards and Cases</router-link></li>
          </ul>
        </div>
        <div><b-btn @click="createEstimateFromPage">Create an Estimate</b-btn></div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-6 col-lg-6 image-pod">
              <router-link :to="{ name: 'general' }">
              <div class="img mountings-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/mountings/interpretive-sign-mountings.jpg') + ')'}"></div>
              <span>General Frames & Mountings</span>
              </router-link>
            </b-col>
            <b-col class="col-12 col-md-6 col-lg-6 image-pod">
              <router-link :to="{ name: 'nps' }">
              <div class="img mountings-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/mountings/NPS-style-exhibit-bases.jpg') + ')'}"></div>
              <span>NPS Style Exhibit Bases</span>
              </router-link>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-7 col-lg-7 image-pod">
              <router-link :to="{ name: 'duraframes' }">
              <div class="img mountings-60-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/mountings/duraFrames.jpg') + ')'}"></div>
              <span>Duraframes & Mountings</span>
              </router-link>
            </b-col>
            <b-col class="col-12 col-md-5 col-lg-5 image-pod">
              <router-link :to="{ name: 'pedestals' }">
              <div class="img mountings-84-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/mountings/pedestal-posts.jpg') + ')'}"></div>
              <span>Pedestals & Posts</span>
              </router-link>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-5 col-lg-5 image-pod">
              <router-link :to="{ name: 'kiosks' }">
              <div class="img mountings-100-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/mountings/kiosks.jpg') + ')'}"></div>
              <span>Kiosks & Structures</span>
              </router-link>
            </b-col>
            <b-col class="col-12 col-md-7 col-lg-7 image-pod">
              <router-link :to="{ name: 'bulletin-boards' }">
              <div class="img mountings-70-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/mountings/bulletin-boards-and-bulletin-cases.jpg') + ')'}"></div>
              <span>Bulletin Boards & Cases</span>
              </router-link>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: 'Mountings'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/Mountings.vue